import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import UnassignedPool from './UnassignedPool';
import MyTickets from './MyTickets';
import TicketDetail from './TicketDetail';
import './SupportEscalations.css';

const SupportEscalations = () => {
  return (
    <div className="support-escalations-container">
      <div className="escalations-header">
        <h2>Back-Office Support Escalations</h2>
      </div>
      <Routes>
        <Route path="/" element={
          <>
            <div className="tabs">
              <NavLink to="/BOD/support-escalations" end className={({ isActive }) => isActive ? 'active' : ''}>Unassigned Pool</NavLink>
              <NavLink to="/BOD/support-escalations/my-tickets" className={({ isActive }) => isActive ? 'active' : ''}>My Tickets</NavLink>
            </div>
            <UnassignedPool />
          </>
        } />
        <Route path="my-tickets" element={
          <>
            <div className="tabs">
              <NavLink to="/BOD/support-escalations" end className={({ isActive }) => isActive ? 'active' : ''}>Unassigned Pool</NavLink>
              <NavLink to="/BOD/support-escalations/my-tickets" className={({ isActive }) => isActive ? 'active' : ''}>My Tickets</NavLink>
            </div>
            <MyTickets />
          </>
        } />
        <Route path=":ticketId" element={<TicketDetail />} />
      </Routes>
    </div>
  );
};

export default SupportEscalations;
